import ElstrLangStore from "elstr-jslib/src/scripts/stores/ElstrLangStore";

export const QuotationContext = {
  Footer: "footer",
  Detail: "Detail",
};

// For mailto links, we need to encode new lines properly
const NEW_LINE = "%0D%0A";

function getQuotationSubject() {
  return `subject=${ElstrLangStore.text("MAIL_QUOTATION_SUBJECT")}`;
}

function getQuotationBody({ context, sMatHdrMatnr = "" }) {
  let body = "body=";
  if (context === QuotationContext.Detail && sMatHdrMatnr) {
    body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_ARTNO")}: ${sMatHdrMatnr}${NEW_LINE}`;
  }

  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_SALUTATION")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_FIRSTNAME")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_SURNAME")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_COMPANY")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_FUNCTION")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_COUNTRY")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_QUANTITY")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_EMAIL")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_PHONE")}: ${NEW_LINE}`;
  body += `${ElstrLangStore.text("MAIL_QUOTATION_BODY_COMMENT")}: `;

  return body;
}

export function addQuotationContext({ context, sMatHdrMatnr = "" }) {
  return `?${getQuotationSubject()}&${getQuotationBody({ context, sMatHdrMatnr })}`;
}
